export const QUICKSTART_UI_STATUS_NOT_LOADED = Symbol('NOT_LOADED');
export const QUICKSTART_UI_STATUS_OPEN = Symbol('OPEN');
export const QUICKSTART_UI_STATUS_MINIMIZED = Symbol('MINIMIZED');
export const QUICKSTART_UI_STATUS_DISMISSED = Symbol('DISMISSED');

export type QuickstartUiStatus =
	| typeof QUICKSTART_UI_STATUS_NOT_LOADED
	| typeof QUICKSTART_UI_STATUS_OPEN
	| typeof QUICKSTART_UI_STATUS_MINIMIZED
	| typeof QUICKSTART_UI_STATUS_DISMISSED;
